import { usePermissionsContext } from "Bands/contexts";
import { useMemo } from "react";
import { API_ENDPOINTS } from "shared/constants";

interface useFirstCheckedGroupPermissionProps {
  name: string;
  rootGroupId: string;
  watchAllFields: { [name: string]: boolean };
}

export const useFirstCheckedGroupPermission = ({
  name,
  rootGroupId,
  watchAllFields,
}: useFirstCheckedGroupPermissionProps) => {
  const { rootGroupPermissions } = usePermissionsContext();
  const groupPermissions = useMemo(
    () => rootGroupPermissions?.[rootGroupId],
    [rootGroupId, rootGroupPermissions]
  );

  const firstCheckedGroupPermission = useMemo(
    () =>
      groupPermissions?.find(
        ({ id }) =>
          name !== API_ENDPOINTS.PERMISSION_TYPE(id) &&
          watchAllFields[API_ENDPOINTS.PERMISSION_TYPE(id)]
      ),
    [groupPermissions, name, watchAllFields]
  );

  return { firstCheckedGroupPermission };
};
